const tema = localStorage.getItem('tema');

export const Colors =
  tema == 'E'
    ? {
        Color1: '#333233',
        Color2: '#1A1A1A',
        Color3: '#42526E',
        Color4: '#6796CF',
        Color5: '#575858',
        Color6: '#9A9A9A',
        Color7: '#B1B1B1',
        Color8: '#2C2C2C',
        Color9: '#F7F8FA',
        Color10: '#A6B2C8',
        Color11: '#F1F3F8',
        Color12: '#434343',
        Color13: '#2A292A',
        Color14: '#8F9DAF',
        Color15: '#FFC6C6', // Vermelho
        Color16: '#C62828', // Vermelho Escuro
        Color17: '#A44747', // Vermelho Escuro
        Color18: '#B1E5A8', // Verde
        Color19: '#298D18', // Verde Escuro
        // Color20: '#50A342', // Verde Escuro
        Color20: '#9BABBE',
        Color21: '#2C2C2C',
        Color22: '#212121',
        Color23: '#1A1A1A',
        Color24: '#2F2F2F',
        color25: '#868585',
        Color26: '#242424',
        Color27: '#1B1B1B',
        Color28: '#4D4D4D',
        Color29: '#272727',
        Color30: '#FFFFFF',
        Color31: '#214B7D',
        Color32: '#1D3553',
        Color33: '#3F9100',
        Color34: '#316A04',
        Color35: '#A67800',
        Color36: '#785804',
        Color37: '#2D2D2D',

        bgColor1: '#FAFCFF', // Cinza - Background Menu Left e Menu Top
        bgColor2: '#FFFFFF', // Branco - Background Main
        bgColor3: '#EAF1FB', // Cinza - Background Modulo Left
        bgColor4: '#ECF4FF', // Azul - Cor de destaque
        bgColor5: '#F1F7FF', // Azul - Hover da Cor de destaque
        bgColor7: '#F1F6FC', // Cinza - Background Campo
        bgColor8: '#F6FAFF', // Cinza - Background Item SubCard
        bgColor9: '#FFD3D3', // Vermelho - Background Item SubCard
        bgColor10: '#F6FAFF', // Azul - Cor do Agrupador

        bgCardColor: '#2A292A',

        bgButton1: '#34639C', // Azul - Cor de Button
        bgButton2: '#EAF1FB', // Cinza - Cor de Button (Cancelar)
        bgButton3: '#42526E', // Azul Escuro - Cor de Button (Filtro)

        bgCard1: '#FFF4AE', // Amarelo - Cor de Card
        bgCard1_2: '#FFF8D5', // Amarelo Claro - Borda Cor de Card
        bgCard2: '#D4E7FF', // Azul - Cor de Card
        bgCard2_2: '#EFF6FF', // Azul Claro - Borda Cor de Card
        bgCard3: '#f2cbff', // Rosa - Cor de Card
        bgCard3_2: '#f7e0ff', // Rosa Claro - Borda Cor de Card
        bgCard4: '#CDF3F1', // Verde - Cor de Card
        bgCard4_2: '#70E2DC', // Verde Claro - Borda Cor de Card
        bgCard5: '#DDDCD5', // Cinza - Cor de Card Desativado
        bgCard5_2: '#EEEEEE', // Cinza Claro - Borda Cor de Card Desativado

        ftColor1: '#42526E', // Cinza Escuro  - Cor dos Títulos e Menus
        ftColor2: '#CCCCCC', // Cinza- Médio - Cor dos SubTitulos e SubMenus
        ftColor3: '#52B4DE', // Azul - Cor de destaque
        ftColor4: '#FFFFFF', // Branco - Textos em cima de outra cor
        ftColor5: '#B1BFD4', // Cinza Claro - Cor do Texto quando está vazio
        ftColor6: '#EF4E4E', // Vermelho - Cor do Texto
        ftColorTitleForm: '#7f858f',

        ftCard1: '#E2C20B', // Amarelo - Cor do Texto no Card
        ftCard1_2: '#CFC8A1', // Cinza Amarelo - Cor do Texto no Card
        ftCard2: '#52B4DE', // Azul - Cor do Texto no Card
        ftCard2_2: '#C8CACC', // Cinza Azul - Cor do Texto no Card
        ftCard3: '#DD7BFF', // Rosa - Cor do Texto no Card
        ftCard3_2: '#c7b2ce', // Cinza Rosa - Cor do Texto no Card
        ftCard4: '#70E2DC', // Verde - Cor do Texto no Card
        ftCard5: '#8C8C8C', // Cinza - Cor do Texto no Card
        ftCard5_2: '#CACACA', // Cinza Cinza - Cor do Texto no Card

        bg_color_1: '#52B4DE', // Azul
        bg_color_2: '#FFFFFF', // Branco
        bg_color_3: '#F1F6FC', // Cinza Azul
        bg_color_4: '#e0eeff', // Cinza Azul Escuro
        bg_color_5: '#F8FAFE', // Cinza Azul Mais Claro
        bg_color_6: '#EFF6FF', // Cinza Azul Claro
        bg_color_7: '#e1ebf5', // Cinza Azul da Borda
        bg_color_8: '#14698D', // Azul
        bg_color_9: '#FBFCFE', // Cinza Azul Ainds Mais Claro
        bg_color_10: '#B1E5A8', // Verde
        bg_color_11: '#298D18', // Verde Escuro
        bg_color_12: '#FFC6C6', // Vermelho
        bg_color_13: '#C62828', // Vermelho Escuro
        bg_color_14: '#F0F0F0', // Cinza Claro

        bg_color_15: '#FFF8D5', // Amarelo Claro
        bg_color_16: '#FFF3B6', // Amarelo

        bg_color_17: '#EFF6FF', // Azul Claro
        bg_color_18: '#D4E7FF', // Azul

        bg_color_19: '#FFDBE8', // Rosa Claro
        bg_color_20: '#FDC0D6', // Rosa

        ft_color_1: '#FFFFFF', // Branco
        ft_color_2: '#52B4DE', // Azul
        ft_color_3: '#828282', // Cinza
        ft_color_4: '#14698D', // Azul Escuro
        ft_color_5: '#BDBDBD', // Cinza Mais Claro
        ft_color_6: '#959595', // Cinza Claro
        ft_color_7: '#50A342', // Verde Escuro Claro
        ft_color_8: '#298D18', // Verde Escuro
        ft_color_9: '#A44747', // Vermelho Escuro Claro
        ft_color_10: '#C62828', // Vermelho Escuro
        ft_color_11: '#D2D2D2', // Cinza Vazio

        ft_color_12: '#C6B871', // Amarelo

        ft_color_13: '#52B4DE', // Azul

        ft_color_14: '#F4699B', // Rosa

        // text_Color_1: '#FFFFFF', // Branco
        text_Color_1: '#B1B1B1',

        Input_Color_1: '#1A1A1A',
        Input_Color_2: '#434343',

        Border_Color_1: '#FFFFFF25', // Cinza - Cor da Borda
      }
    : {
        Color1: '#FFFFFF',
        Color2: '#F2F7F9',
        Color3: '#42526E',
        Color4: '#6796CF',
        Color5: '#575858',
        Color6: '#9A9A9A',
        Color7: '#B1B1B1',
        Color8: '#DAEDF6',
        Color9: '#F7F8FA',
        Color10: '#A6B2C8',
        Color11: '#F1F3F8',
        Color12: '#e5e5e5',
        Color13: '#FFFFFF', //Era #2A292A
        Color14: '#8F9DAF',
        Color15: '#FFC6C6', // Vermelho
        Color16: '#C62828', // Vermelho Escuro
        Color17: '#A44747', // Vermelho Escuro
        Color18: '#B1E5A8', // Verde
        Color19: '#298D18', // Verde Escuro
        // Color20: '#50A342', // Verde Escuro
        Color20: '#9BABBE',
        Color21: '#E4EEF6',
        Color22: '#E4EEF6',
        Color23: '#E4EEF6',
        Color24: '#FFFFFF',
        color25: '#868585',
        Color26: '#FFFFFF',
        Color29: '#272727',
        Color30: '#FFFFFF',
        Color31: '#214B7D',
        Color32: '#1D3553',
        Color33: '#3F9100',
        Color34: '#316A04',
        Color35: '#A67800',
        Color36: '#785804',
        Color37: '#2D2D2D',

        bgColor1: '#FAFCFF', // Cinza - Background Menu Left e Menu Top
        bgColor2: '#FFFFFF', // Branco - Background Main
        bgColor3: '#EAF1FB', // Cinza - Background Modulo Left
        bgColor4: '#ECF4FF', // Azul - Cor de destaque
        bgColor5: '#F1F7FF', // Azul - Hover da Cor de destaque
        bgColor7: '#F1F6FC', // Cinza - Background Campo
        bgColor8: '#F6FAFF', // Cinza - Background Item SubCard
        bgColor9: '#FFD3D3', // Vermelho - Background Item SubCard
        bgColor10: '#F6FAFF', // Azul - Cor do Agrupador

        bgCardColor: '#ffffff10',

        bgButton1: '#34639C', // Azul - Cor de Button
        bgButton2: '#EAF1FB', // Cinza - Cor de Button (Cancelar)
        bgButton3: '#42526E', // Azul Escuro - Cor de Button (Filtro)

        bgCard1: '#FFF4AE', // Amarelo - Cor de Card
        bgCard1_2: '#FFF8D5', // Amarelo Claro - Borda Cor de Card
        bgCard2: '#D4E7FF', // Azul - Cor de Card
        bgCard2_2: '#EFF6FF', // Azul Claro - Borda Cor de Card
        bgCard3: '#f2cbff', // Rosa - Cor de Card
        bgCard3_2: '#f7e0ff', // Rosa Claro - Borda Cor de Card
        bgCard4: '#CDF3F1', // Verde - Cor de Card
        bgCard4_2: '#70E2DC', // Verde Claro - Borda Cor de Card
        bgCard5: '#DDDCD5', // Cinza - Cor de Card Desativado
        bgCard5_2: '#EEEEEE', // Cinza Claro - Borda Cor de Card Desativado

        ftColor1: '#42526E', // Cinza Escuro  - Cor dos Títulos e Menus
        ftColor2: '#CCCCCC', // Cinza- Médio - Cor dos SubTitulos e SubMenus
        ftColor3: '#52B4DE', // Azul - Cor de destaque
        ftColor4: '#FFFFFF', // Branco - Textos em cima de outra cor
        ftColor5: '#B1BFD4', // Cinza Claro - Cor do Texto quando está vazio
        ftColor6: '#EF4E4E', // Vermelho - Cor do Texto
        ftColorTitleForm: '#7f858f',

        ftCard1: '#E2C20B', // Amarelo - Cor do Texto no Card
        ftCard1_2: '#CFC8A1', // Cinza Amarelo - Cor do Texto no Card
        ftCard2: '#52B4DE', // Azul - Cor do Texto no Card
        ftCard2_2: '#C8CACC', // Cinza Azul - Cor do Texto no Card
        ftCard3: '#DD7BFF', // Rosa - Cor do Texto no Card
        ftCard3_2: '#c7b2ce', // Cinza Rosa - Cor do Texto no Card
        ftCard4: '#70E2DC', // Verde - Cor do Texto no Card
        ftCard5: '#8C8C8C', // Cinza - Cor do Texto no Card
        ftCard5_2: '#CACACA', // Cinza Cinza - Cor do Texto no Card

        bg_color_1: '#52B4DE', // Azul
        bg_color_2: '#FFFFFF', // Branco
        bg_color_3: '#F1F6FC', // Cinza Azul
        bg_color_4: '#e0eeff', // Cinza Azul Escuro
        bg_color_5: '#F8FAFE', // Cinza Azul Mais Claro
        bg_color_6: '#EFF6FF', // Cinza Azul Claro
        bg_color_7: '#e1ebf5', // Cinza Azul da Borda
        bg_color_8: '#14698D', // Azul
        bg_color_9: '#FBFCFE', // Cinza Azul Ainds Mais Claro
        bg_color_10: '#B1E5A8', // Verde
        bg_color_11: '#298D18', // Verde Escuro
        bg_color_12: '#FFC6C6', // Vermelho
        bg_color_13: '#C62828', // Vermelho Escuro
        bg_color_14: '#F0F0F0', // Cinza Claro

        bg_color_15: '#FFF8D5', // Amarelo Claro
        bg_color_16: '#FFF3B6', // Amarelo

        bg_color_17: '#EFF6FF', // Azul Claro
        bg_color_18: '#D4E7FF', // Azul

        bg_color_19: '#FFDBE8', // Rosa Claro
        bg_color_20: '#FDC0D6', // Rosa

        ft_color_1: '#FFFFFF', // Branco
        ft_color_2: '#52B4DE', // Azul
        ft_color_3: '#828282', // Cinza
        ft_color_4: '#14698D', // Azul Escuro
        ft_color_5: '#BDBDBD', // Cinza Mais Claro
        ft_color_6: '#959595', // Cinza Claro
        ft_color_7: '#50A342', // Verde Escuro Claro
        ft_color_8: '#298D18', // Verde Escuro
        ft_color_9: '#A44747', // Vermelho Escuro Claro
        ft_color_10: '#C62828', // Vermelho Escuro
        ft_color_11: '#D2D2D2', // Cinza Vazio

        ft_color_12: '#C6B871', // Amarelo

        ft_color_13: '#52B4DE', // Azul

        ft_color_14: '#F4699B', // Rosa

        text_Color_1: '#52B4DE',

        Input_Color_1: '#E4EEF6',
        Input_Color_2: '#e5e5e5',

        Border_Color_1: '#6796cf50', // Cinza - Cor da Borda
      };
